import { arrow_algorithm } from './fine_arrow'
/**** 进攻方向 */
const assault_Direction_opts = {
    tailWidthFactor: 0.2,
    neckWidthFactor: 0.25,
    headWidthFactor: 0.3,
    headAngle: Math.PI / 4,
    neckAngle: Math.PI * 0.17741
}


export default function (coordinates) {
    return arrow_algorithm(coordinates, assault_Direction_opts);
}